import component from './GuestsRoomsChildrenPortal';

export default component;
